import { createFileRoute } from '@tanstack/react-router'
import { LoginPage } from '@/features/auth/components/login-page'

export const Route = createFileRoute('/_app/login/_layout/')({
  component: LoginPage,
})
